import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import SydModal from '../../../../../commonDesign/SydModal'
import EditApiOutputsForm from './form'

const EditApiOutputsDialog = React.forwardRef(function EditApiOutputsDialog ({ onComplete }, ref) {
  const [dialogState, setDialogState] = useState({ open: false, processing: false })

  const close = useCallback(() => {
    setDialogState({ open: false, processing: false })
  }, [setDialogState])

  const handleComplete = useCallback((e) => {
    close()
    onComplete(e)
  }, [close, onComplete])

  useImperativeHandle(ref, () => ({
    open: (dataSource) => setDialogState({
      open: true,
      processing: false,
      dataSource
    })
  }), [setDialogState])

  return (
    <SydModal
      title='Edit API Outputs'
      subtitle={dialogState.dataSource?.displayName}
      open={dialogState.open}
      onClose={close}
      size='large'
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (
          <EditApiOutputsForm
            dataSource={dialogState.dataSource}
            onComplete={handleComplete}
            onCancel={close}
          />
        ) : null}
      </div>
    </SydModal>
  )
})

EditApiOutputsDialog.propTypes = {
  onComplete: PropTypes.func
}

EditApiOutputsDialog.defaultProps = {
  onComplete: () => {}
}

export default EditApiOutputsDialog
